import { ReactNode } from 'react';
import { TextContent } from '@amzn/awsui-components-react';
import { IdPs } from '../constants/providers';

export type LogoutInfo = {
  displayName: string;
  instructions: ReactNode;
};

export const getLogoutInstructions = (idp: IdPs): LogoutInfo => {
  return idpLogoutInfo[idp];
};

const genericEnterpriseInstructions = (
  <TextContent>
    To completely sign out, logout from your Enterprise SSO.
  </TextContent>
);

const idpLogoutInfo: { [i in IdPs]: LogoutInfo } = {
  [IdPs.OTP]: {
    displayName: '',
    instructions: <></>,
  },
  [IdPs.AWSBuilderID]: {
    displayName: 'AWS Builder ID',
    instructions: (
      <TextContent>
        To completely sign out, please follow{' '}
        <a
          href="https://docs.aws.amazon.com/signin/latest/userguide/sign-out-all-aws_builder_id.html"
          target="_blank"
          rel="noreferrer"
        >
          these instructions
        </a>
        .
      </TextContent>
    ),
  },
  [IdPs.LoginWithAmazon]: {
    displayName: 'Amazon',
    instructions: (
      <TextContent>
        To completely sign out, please follow{' '}
        <a
          href="https://www.amazon.com/gp/help/customer/display.html?nodeId=GQL359FK7DM8294C"
          target="_blank"
          rel="noreferrer"
        >
          these instructions
        </a>
        .
      </TextContent>
    ),
  },
  [IdPs.AWSSignIn]: { displayName: 'AWS', instructions: <></> },
  [IdPs.AmazonFederate]: {
    displayName: 'Amazon Federate',
    instructions: (
      <TextContent>
        To completely sign out, please follow{' '}
        <a
          href="https://w.amazon.com/bin/view/NextGenMidway/FAQ#How_do_I_logout_of_NextGen_Midway_so_I_can_test_login_.2F_reset_my_timeout_to_20_hours_before_starting_work_I_don.27t_want_interrupted.3F"
          target="_blank"
          rel="noreferrer"
        >
          these instructions
        </a>
        .
      </TextContent>
    ),
  },
  [IdPs.AmazonSystemFederate]: {
    displayName: 'Amazon System Federate',
    instructions: <></>,
  },
  [IdPs.ADFS]: {
    displayName: 'ADFS',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.JPMC]: {
    displayName: 'JPMC',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.ScaleTestIdp]: { displayName: 'Scale Test IDP', instructions: <></> },
  [IdPs.AWSPartnerNetwork]: {
    displayName: 'AWS Partner Network',
    instructions: (
      <TextContent>
        To completely sign out, please visit{' '}
        <a
          href="https://partnercentral.awspartner.com/home"
          target="_blank"
          rel="noreferrer"
        >
          AWS Partner Central
        </a>{' '}
        and click on logout.
      </TextContent>
    ),
  },
  [IdPs.Accenture]: {
    displayName: 'Accenture',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.AccentureUAT]: {
    displayName: 'AccentureUAT',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.testProvider]: { displayName: 'test Provider', instructions: <></> },
  [IdPs.BestBuy]: {
    displayName: 'Best Buy',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.Westpac]: {
    displayName: 'Westpac',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.Sophos]: {
    displayName: 'Sophos',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.Shell]: {
    displayName: 'Shell',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.Jefferies]: {
    displayName: 'Jefferies',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.Curtin]: {
    displayName: 'Curtin',
    instructions: genericEnterpriseInstructions,
  },
  [IdPs.Principal]: {
    displayName: 'Principal',
    instructions: genericEnterpriseInstructions,
  },
};
